import * as Sentry from '@sentry/react';
import {Integrations} from "@sentry/tracing";
import 'assets/css/core.css';
import 'assets/css/reset.css';
import 'assets/fonts/fonts.css';
import {Preloader} from "components/Preloader";
import {retryFailLoad} from "modules/utils/lazy_load";

import React, {lazy, Suspense} from "react";
import ReactDOM from 'react-dom';
import {unregister as unregisterServiceWorker} from './serviceWorker';

Sentry.init({
	dsn: "https://6c239adcc6694d00926ceef1dd8f0c5e@o151969.ingest.sentry.io/5356427",
	environment: process.env.REACT_APP_SENTRY_ENV,
	release     : process.env.REACT_APP_RELEASE_VERSION,
	allowUrls   : [
		'play.buffalowildwings.com',
		'.fanhubmedia.com'
	],
	integrations: [
		new Integrations.BrowserTracing(),
		new Sentry.Integrations.Breadcrumbs({
			console: false
		})
	],
	denyUrls    : [
		"quantcast",
		"xsca",
		// browser's extensions
		/extensions\//i,
		/^chrome:\/\//i,
		/^moz-extension:\/\//i
	],
	ignoreErrors: [
		/undefined is not an object\(evaluating '\w.user'\)/gm,
		"Cannot read properties of undefined (reading 'user')",
		"undefined is not an object (evaluating 'i.user')",
		"404 while login user, register according: 404, User_not_registered",
		"User_already_registered",
		"Bww_id must not be empty",
		"Please enter another name and refrain from using profanity.",
		"Authentication Required",
		"Load failed",
		"Failed to fetch",
	],
	sampleRate: 0.1
});

const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME || '';

const ProjectIndex = lazy(retryFailLoad(() => import(`apps/${process.env.REACT_APP_PROJECT_NAME || ''}`)));

const APP: React.FC = Sentry.withProfiler(() => (
	<Suspense fallback={<Preloader/>}>
		<ProjectIndex/>
	</Suspense>
));

if ( PROJECT_NAME ) {
	ReactDOM.render(( <APP/> ), document.getElementById('root'));
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregisterServiceWorker();
